$(() => {
  const getData = window?.getData
  $('.js-sign-in').one('click', (e) => {
    if (typeof getData !== 'undefined') {
      e.preventDefault();
      getData.postMessage('sign_in')
    }
  })
})

window.receiveFromApp = (token) => {
  $.ajax({
    type: 'POST',
    url: '/devices',
    dataType: 'json',
    data: {
      device: { token: token },
    },
  })
    .done(() => {
      // ログインボタン押下
      const signInLink = document.querySelector('a.js-sign-in')
      if (signInLink) {
        $('.js-sign-in').off()
        signInLink.click()
      }
    })
    .fail((e) => {
      console.error(e)
    })
}
